import { z } from 'my-zod'
import { polarisRentalProductModel } from './polaris-rental-product-model'
import { enumOptionsToObject, SuperProductLineEnum } from '../../internal'

export const crossVersionStatusOptions = ['Draft', 'Published', 'Retired', 'Published with Draft'] as const
export const crossVersionStatuses = enumOptionsToObject(crossVersionStatusOptions)
export type crossVersionStatus = (typeof crossVersionStatusOptions)[number]

export const polarisRentalProductSystemView = polarisRentalProductModel.augment({
  outfitterBusinessName: z.string(),
  superProductLine: z.enum([...SuperProductLineEnum._def.values, 'Custom']).nullable(),
  crossVersionStatus: z.enum(crossVersionStatusOptions),
  position: z.number().nullish()
})
export type polarisRentalProductSystemView = z.infer<typeof polarisRentalProductSystemView>
